/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weird_Zany_Gazelle_TapInputs */

const fr_weird_zany_gazelle_tap = /** @type {(inputs: Weird_Zany_Gazelle_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`le`)
};

/**

* @param {Weird_Zany_Gazelle_TapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weird_zany_gazelle_tap = /** @type {((inputs?: Weird_Zany_Gazelle_TapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weird_Zany_Gazelle_TapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weird_zany_gazelle_tap(inputs)
});